<div class="card m-2">
  <div class="input-group ml-2 mr-2 mt-2 w-75 align-self-end">
    <div class="input-group-prepend">
      <span class="input-group-text">
        <fa-icon aria-hidden="true"
                 [icon]="icons.faSearch"></fa-icon>
      </span>
    </div>
    <input type="text"
           class="form-control"
           ngbTooltip="Ricerca objects"
           placeholder="Filtro"
           (input)="searchData($event)"
           aria-label="filtro">
  </div>

  <app-related-item *ngFor="let item of relatedItemsPagination; trackBy:onTrackRelatedItemsBy;"
                    [relatedItem]="item"
                    [selectedRelatedItemBackground]="selectedObjectBackground$ | async"
                    (selectRelatedObjectToHighlightEvent)="handleSelectRelatedObjectToHighlight($event)"
                    (selectRelatedObjectForEditGeometryEvent)="handleSelectRelatedObjectEditGeometry($event)"
                    (deselectRelatedObjectEvent)="handleDeselectRelatedObjectGeometry($event)"
                    (selectRelatedObjectInfoEvent)="handleSelectRelatedObjectInfo($event)">
  </app-related-item>

  <div class="ml-2 mr-2 mt-2">
    <pagination [collectionSize]="filteredRelatedItems.length"
                [page]="1"
                [pageSize]="pageSize"
                [allData]="filteredRelatedItems"
                (listPagination)="getListPagination($event)"
                [float]="'right'"></pagination>
  </div>
</div>